import { defineRouting } from "next-intl/routing";

export const routing = defineRouting({
  // A list of all locales that are supported
  locales: ["en", "ar"],
  // Used when no locale matches
  defaultLocale: "en",
  // Hide default locale prefix ('en') in the URL path, e.g. /stopwatch instead of /en/stopwatch
  localePrefix: "as-needed",
});

export type Locale = (typeof routing.locales)[number];

export function resolveLocale(value: string | undefined): Locale {
  return (
    routing.locales.find((supportedLocale) => supportedLocale === value) ??
    routing.defaultLocale
  );
}
